import axios from "axios";
import { API_URL } from "../network/api";

const useAxios = () => {
  const token = localStorage.getItem("token");
  const instance = axios.create({
    baseURL: `${API_URL}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  instance.interceptors.request.use(
    (request) => {
      const relatedShop = localStorage.getItem("shopID");
      if (relatedShop) {
        request.params = {
          ...request.params,
          relatedShop,
        };
        if (
          request.method === "post" ||
          request.method === "put" ||
          request.method === "patch"
        ) {
          if (request.data instanceof FormData) {
            request.data.append("relatedShop", relatedShop);
          } else {
            request.data = {
              ...request.data,
              relatedShop: relatedShop,
            };
          }
        }
      }
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export default useAxios;
